import { useSelector } from "react-redux";
import { useIsMount } from "./useIsMount.js";

export default function useShowSSRVersion() {
  const ssr = useSelector((state) => state.data.ssr);
  const isFirstMount = useIsMount();

  return ssr && isFirstMount;
}
